import { connect } from 'react-redux'
import WishlistComponent from '../components'
import { syncWishlistedProductsToStore, removeWishlistedProduct } from '../actions/ApiRequest'

const mapStateToProps = (state) => ({
  products: state.buyerWishlist.products,
  isLoading: state.buyerWishlist.isLoading,
})

const mapDispatchToProps = (dispatch) => ({
  syncWishlistedProductsToStore: () => dispatch(syncWishlistedProductsToStore()),
  removeWishlistedProduct: (product) => dispatch(removeWishlistedProduct(product))
})

const Wishlist = connect(mapStateToProps, mapDispatchToProps)(WishlistComponent)

export default Wishlist
